import http from "../../services/http";
import { AxiosResponse } from "axios";
import { Store as appState } from "../reducers";
import { ThunkDispatch, ThunkAction } from "redux-thunk";
import { LOAD_CONFIGURATION } from "../actionTypes";
import { LoadConfigurationResponse } from "../reducers/load";
import { History } from "history";
import { Configuration } from "../../components/main/history/HistoryView";
import { preserveSaveDetailsData } from "../actions";

export default function loadConfiguration([historyItem, history]: [
	Configuration,
	History<any>
]): ThunkAction<Promise<void>, appState, {}, any> {
	return function(dispatch: ThunkDispatch<any, any, any>) {
		return http.getConfiguration(historyItem.Id).then(
			(response: AxiosResponse<LoadConfigurationResponse>) => {
				const {
					data: {
						Vehicle: { ModelId }
					}
				} = response;

				// Load data from history into state
				dispatch({
					type: LOAD_CONFIGURATION,
					payload: {
						...response.data,
						heroImgUrl: historyItem.Model.HeroImageUrl
					}
				});

				if (response.data && response.data.Configuration)
					dispatch(
						preserveSaveDetailsData(response.data.Configuration.SaveDetails)
					);

				// Redirect to configuration view
				history.push(`/configuration/${ModelId}/categories`);
			},
			(reason: any) => {
				console.error(
					"An error occured while trying to load a configuration:",
					reason
				);
			}
		);
	};
}
